import get_by_vender_statistics, {
  GetByVenderStatisticsResponse,
} from "lib/worker/api/get_by_vender_statistics";
import start_game from "lib/worker/api/start_game";
import { useEffect, useState } from "react";
import Img from "react-cloudimage-responsive";
import { MaxButton, StatusMaxButton } from "./button";
import Spinner from "./loader";

interface TopBannerOtherCasinoProps {
  logo: string;
  desc: string;
  campName: string;
  isButton?: boolean | undefined;
  venderPrefix?: string | undefined;
  symbol?: string | undefined;
  isButtonDesktop?: boolean | undefined;
  isButtonMobile?: boolean | undefined;
  device?: string | undefined;
}

export function TopBannerOtherCasino(props: TopBannerOtherCasinoProps) {
  const { logo, desc, campName } = props;
  const {
    isButton,
    venderPrefix,
    symbol,
    isButtonDesktop,
    isButtonMobile,
    device,
  } = props;

  const [statistics, setStatistics] = useState<GetByVenderStatisticsResponse>();
  const [isLoading, setIsloading] = useState<boolean>(false);

  useEffect(() => {
    setIsloading(true);
    get_by_vender_statistics({ vender_prefix: venderPrefix ?? "" })
      .then((json) => {
        setStatistics(json);
      })
      .finally(() => {
        setIsloading(false);
      });
  }, []);

  return (
    <>
      <div className="bg-blue-fade" style={{ marginTop: -5 }}>
        <div className="container">
          <div className="grid row">
            <div
              style={{
                borderRadius: 20,
                width: 160,
                height: 160,
                marginBottom: 20,
              }}
            >
              <div className="zoom" style={{ paddingTop: 0, paddingBottom: 0 }}>
                <Img
                  ratio={0.9 / 1}
                  className="full-width-image margin-top-10 margin-bottom-10"
                  src={logo}
                  alt={campName}
                ></Img>
              </div>
            </div>
            <div className="col">
              <div>
                <div style={{ marginTop: 30, marginLeft: 0 }}>
                  <h1 className="font-bold" style={{ fontSize: 22 }}>
                    {campName}
                  </h1>
                  <div className="font-whiteblue">{desc}</div>
                  <div className="row">
                    <div className="mt-3">
                      {isButton && (
                        <div style={{ marginTop: 10 }}>
                          <MaxButton
                            title="เล่น"
                            className="shadow"
                            status={StatusMaxButton.playgame}
                            onClick={() => {
                              start_game({
                                VenderPrepix: venderPrefix,
                                Symbol: symbol,
                              });
                            }}
                          ></MaxButton>
                        </div>
                      )}
                      {isButtonDesktop && (
                        <MaxButton
                          style={{ width: 75, fontSize: 14 }}
                          title="เล่นแบบดั้งเดิม"
                          className="shadow"
                          status={StatusMaxButton.playgame}
                          onClick={() => {
                            start_game({
                              VenderPrepix: venderPrefix,
                              Symbol: symbol,
                            });
                          }}
                        ></MaxButton>
                      )}
                      {isButtonMobile && (
                        <MaxButton
                          style={{ width: 95, fontSize: 14, marginLeft: 5 }}
                          title="เล่นเวอร์ชั่นมือถือ"
                          className="shadow"
                          status={StatusMaxButton.playgame}
                          onClick={() => {
                            start_game({
                              VenderPrepix: venderPrefix,
                              Symbol: symbol,
                              Device: device,
                            });
                          }}
                        ></MaxButton>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className="bottom-line-black"
              style={{ marginTop: 20, opacity: 1 }}
            ></div>
            <div className="col-4 col-md-4 border-right-blue">
              <div style={{ marginTop: 10 }}>
                <div
                  className="font-whiteblue font-bold text-center"
                  style={{ fontSize: 12 }}
                >
                  เดิมพัน
                </div>
                <div
                  className="font-bold text-center "
                  style={{ fontSize: 14, marginTop: 2 }}
                >
                  {isLoading ? (
                    <Spinner></Spinner>
                  ) : (
                    statistics?.BetCount?.format(0, 0)
                  )}
                </div>
                <div
                  className="font-whiteblue text-center"
                  style={{ fontSize: 12, marginTop: 2 }}
                >
                  ครั้ง
                </div>
              </div>
            </div>
            <div className="col-4 col-md-4 border-right-blue">
              <div style={{ marginTop: 10 }}>
                <div
                  className="font-whiteblue font-bold text-center"
                  style={{ fontSize: 12 }}
                >
                  ผู้เล่น
                </div>
                <div
                  className="font-bold text-center"
                  style={{ fontSize: 14, marginTop: 2 }}
                >
                  {isLoading ? (
                    <Spinner></Spinner>
                  ) : (
                    statistics?.MemberCount?.format(0, 0)
                  )}
                </div>
                <div
                  className="font-whiteblue text-center"
                  style={{ fontSize: 12, marginTop: 2, marginBottom: 20 }}
                >
                  คน
                </div>
              </div>
            </div>
            <div className="col-4 col-md-4">
              <div style={{ marginTop: 10 }}>
                <div
                  className="font-whiteblue font-bold text-center"
                  style={{ fontSize: 12 }}
                >
                  รายได้สูงสุด
                </div>
                <div
                  className="font-bold text-center"
                  style={{ fontSize: 14, marginTop: 2 }}
                >
                  {isLoading ? (
                    <Spinner></Spinner>
                  ) : (
                    statistics?.HighestIncome?.format(0, 0)
                  )}
                </div>
                <div
                  className="font-whiteblue text-center"
                  style={{ fontSize: 12, marginTop: 2 }}
                >
                  บาท
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
